import { render, staticRenderFns } from "./Overviewcomp.vue?vue&type=template&id=c643d328&scoped=true&"
import script from "./Overviewcomp.vue?vue&type=script&lang=js&"
export * from "./Overviewcomp.vue?vue&type=script&lang=js&"
import style0 from "./Overviewcomp.vue?vue&type=style&index=0&id=c643d328&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c643d328",
  null
  
)

export default component.exports